import appConfig from "../config/app.config.js";

const prefix = appConfig.storagePrefix;

export const storage = {
  // Token methods
  getToken: () => localStorage.getItem(`${prefix}token`),
  setToken: (token) => localStorage.setItem(`${prefix}token`, token),
  clearToken: () => localStorage.removeItem(`${prefix}token`),

  // User methods
  getUser: () => {
    const user = localStorage.getItem(`${prefix}user`);
    return user ? JSON.parse(user) : null;
  },
  setUser: (user) =>
    localStorage.setItem(`${prefix}user`, JSON.stringify(user)),
  clearUser: () => localStorage.removeItem(`${prefix}user`),

  // Clear all app storage
  clearAll: () => {
    localStorage.removeItem(`${prefix}token`);
    localStorage.removeItem(`${prefix}user`);
    // Add other items as needed
  },
};
